const Import = {
  sm: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66699 10.3893L8.66699 2.00062C8.66699 1.63195 8.36832 1.33395 8.00032 1.33395C7.63166 1.33395 7.33366 1.63195 7.33366 2.00062L7.33366 10.3893L4.58566 7.64195C4.32499 7.38128 3.90299 7.38128 3.64299 7.64195C3.38232 7.90262 3.38232 8.32395 3.64299 8.58462L7.41432 12.3559C7.43366 12.3753 7.45432 12.3933 7.47499 12.4093C7.59766 12.5659 7.78699 12.6653 8.00032 12.6653C8.21299 12.6653 8.40299 12.5659 8.52499 12.4093C8.54566 12.3933 8.56699 12.3753 8.58566 12.3559L12.357 8.58462C12.6177 8.32395 12.6177 7.90262 12.357 7.64195C12.097 7.38128 11.675 7.38128 11.4143 7.64195L8.66699 10.3893Z"
        className="icon-color"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.00033 13.3334L14.0003 13.3334C14.367 13.3334 14.667 13.6334 14.667 14.0001C14.667 14.3667 14.367 14.6667 14.0003 14.6667L2.00033 14.6667C1.63299 14.6667 1.33366 14.3667 1.33366 14.0001C1.33366 13.6334 1.63299 13.3334 2.00033 13.3334Z"
        className="icon-color"
        fill="black"
      />
    </svg>
  ),
  md: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66699 10.3893L8.66699 2.00062C8.66699 1.63195 8.36832 1.33395 8.00032 1.33395C7.63166 1.33395 7.33366 1.63195 7.33366 2.00062L7.33366 10.3893L4.58566 7.64195C4.32499 7.38128 3.90299 7.38128 3.64299 7.64195C3.38232 7.90262 3.38232 8.32395 3.64299 8.58462L7.41432 12.3559C7.43366 12.3753 7.45432 12.3933 7.47499 12.4093C7.59766 12.5659 7.78699 12.6653 8.00032 12.6653C8.21299 12.6653 8.40299 12.5659 8.52499 12.4093C8.54566 12.3933 8.56699 12.3753 8.58566 12.3559L12.357 8.58462C12.6177 8.32395 12.6177 7.90262 12.357 7.64195C12.097 7.38128 11.675 7.38128 11.4143 7.64195L8.66699 10.3893Z"
        className="icon-color"
        fill="black"
      />
      <path
        fillRule="evenodd"
        className="icon-color"
        clipRule="evenodd"
        d="M2.00033 13.3334L14.0003 13.3334C14.367 13.3334 14.667 13.6334 14.667 14.0001C14.667 14.3667 14.367 14.6667 14.0003 14.6667L2.00033 14.6667C1.63299 14.6667 1.33366 14.3667 1.33366 14.0001C1.33366 13.6334 1.63299 13.3334 2.00033 13.3334Z"
        fill="black"
      />
    </svg>
  ),
}

export default Import
